import { Airline } from "v2/modules/types/intake-funnel";

const compareProps: (keyof Airline)[] = ["name", "displayName", "code", "iata"];

const isAirlineDuplicated = (airline1: Airline, airlines: Airline[]) => {
  return airlines.some((airline2) => {
    return compareProps.every((prop) => {
      const hasProp1 = Object.prototype.hasOwnProperty.call(airline1, prop);
      const hasProp2 = Object.prototype.hasOwnProperty.call(airline2, prop);

      if (!hasProp1 || !hasProp2) return false;

      const value1 = airline1[prop];
      const value2 = airline2[prop];

      return value1 === value2;
    });
  });
};

export const airlineFilter = (airlines: Airline[]): Airline[] => {
  return airlines.reduce((acc: Airline[], airline) => {
    if (acc.length > 0 && isAirlineDuplicated(airline, acc)) {
      return acc;
    }

    return [...acc, airline];
  }, []);
};
